export default {
  badge: 'Testi',
  badge_title: 'Testiravintola',
  notice: 'Tämä on testiravintola. Täällä tehdyt tilaukset ovat testausta varten.',
};
